// Slow editorial marquee — low contrast, elegant, typographic texture only.
export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-[#1e1e1e] bg-[#050505] py-8 ${className}`}
    >
      <div className="marquee-track flex whitespace-nowrap">
        {doubled.map((w, i) => (
          <span
            key={i}
            className="font-editorial italic text-[clamp(2.5rem,6vw,6rem)] leading-none text-[#2a2a2a] px-8 select-none"
          >
            {w} <span className="text-[#FF3B30] not-italic">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
